import React, { useState, useMemo } from 'react';
import { SECTIONS, DB } from '../data/ingredients';
import styles from './RecipeImport.module.css';

// ── Known name aliases: imported text → { section, dbName } ──────
// Expand this list over time as new recipes come in
const ALIASES = {
  // Cures
  'insta cure #1':          { section: 'cure',   name: 'Prague Powder #1 (Cure #1)' },
  'instacure #1':           { section: 'cure',   name: 'Prague Powder #1 (Cure #1)' },
  'cure #1':                { section: 'cure',   name: 'Prague Powder #1 (Cure #1)' },
  'pink salt':              { section: 'cure',   name: 'Prague Powder #1 (Cure #1)' },
  'curing salt':            { section: 'cure',   name: 'Prague Powder #1 (Cure #1)' },
  'prague powder #1':       { section: 'cure',   name: 'Prague Powder #1 (Cure #1)' },
  // Meats
  'pork shoulder':          { section: 'meat',   name: 'Pork Shoulder (Boston Butt)' },
  'pork butt':              { section: 'meat',   name: 'Pork Shoulder (Boston Butt)' },
  'boston butt':            { section: 'meat',   name: 'Pork Shoulder (Boston Butt)' },
  'beef chuck':             { section: 'meat',   name: 'Beef Chuck' },
  'pork loin':              { section: 'meat',   name: 'Pork Loin' },
  'chicken thigh':          { section: 'meat',   name: 'Chicken Thigh (boneless)' },
  'turkey breast':          { section: 'meat',   name: 'Turkey Breast' },
  // Fats
  'pork back fat':          { section: 'fat',    name: 'Pork Back Fat' },
  'back fat':               { section: 'fat',    name: 'Pork Back Fat' },
  'pork fat':               { section: 'fat',    name: 'Pork Back Fat' },
  'pork belly':             { section: 'fat',    name: 'Pork Belly' },
  // Liquids
  'water':                  { section: 'liquid', name: 'Water (ice cold)' },
  'ice water':              { section: 'liquid', name: 'Water (ice cold)' },
  'ice':                    { section: 'liquid', name: 'Ice' },
  'cold water':             { section: 'liquid', name: 'Water (ice cold)' },
  'red wine':               { section: 'liquid', name: 'Red Wine' },
  'beer':                   { section: 'liquid', name: 'Beer' },
  // Salts
  'kosher salt':            { section: 'salt',   name: 'Kosher Salt' },
  'sea salt':               { section: 'salt',   name: 'Sea Salt (fine)' },
  'table salt':             { section: 'salt',   name: 'Table Salt (non-iodized)' },
  'salt':                   { section: 'salt',   name: 'Kosher Salt' },
  // Binders
  'potato starch':          { section: 'binder', name: 'Potato Starch' },
  'corn starch':            { section: 'binder', name: 'Corn Starch' },
  'nfdm':                   { section: 'binder', name: 'Non-fat Dry Milk Powder' },
  'non-fat dry milk':       { section: 'binder', name: 'Non-fat Dry Milk Powder' },
  'dry milk powder':        { section: 'binder', name: 'Non-fat Dry Milk Powder' },
  'milk powder':            { section: 'binder', name: 'Non-fat Dry Milk Powder' },
  'soy protein':            { section: 'binder', name: 'Soy Protein Concentrate' },
  'tapioca starch':         { section: 'binder', name: 'Tapioca Starch' },
  // Spices
  'black pepper':           { section: 'spice',  name: 'Black Pepper (ground)' },
  'white pepper':           { section: 'spice',  name: 'White Pepper (ground)' },
  'cayenne pepper':         { section: 'spice',  name: 'Cayenne Pepper' },
  'cayenne':                { section: 'spice',  name: 'Cayenne Pepper' },
  'dried thyme':            { section: 'spice',  name: 'Dried Thyme' },
  'thyme':                  { section: 'spice',  name: 'Dried Thyme' },
  'garlic powder':          { section: 'spice',  name: 'Garlic Powder' },
  'onion powder':           { section: 'spice',  name: 'Onion Powder' },
  'paprika':                { section: 'spice',  name: 'Paprika (sweet)' },
  'smoked paprika':         { section: 'spice',  name: 'Paprika (smoked)' },
  'nutmeg':                 { section: 'spice',  name: 'Nutmeg (ground)' },
  'marjoram':               { section: 'spice',  name: 'Dried Marjoram' },
  'dried marjoram':         { section: 'spice',  name: 'Dried Marjoram' },
  'coriander':              { section: 'spice',  name: 'Ground Coriander' },
  'allspice':               { section: 'spice',  name: 'Allspice (ground)' },
  'red pepper flakes':      { section: 'spice',  name: 'Red Pepper Flakes' },
  'mustard seed':           { section: 'spice',  name: 'Ground Mustard Seed' },
  'ground mustard':         { section: 'spice',  name: 'Ground Mustard Seed' },
  // Sweeteners
  'dextrose':               { section: 'sweet',  name: 'Dextrose (glucose)' },
  'sugar':                  { section: 'sweet',  name: 'White Granulated Sugar' },
  'brown sugar':            { section: 'sweet',  name: 'Brown Sugar' },
  'maple syrup':            { section: 'sweet',  name: 'Maple Syrup' },
  // Cheese
  'cheddar cheese':         { section: 'cheese', name: 'Cheddar Cheese (cubed)' },
  // Flavor
  'liquid smoke':           { section: 'flavor', name: 'Liquid Smoke' },
  'worcestershire':         { section: 'flavor', name: 'Worcestershire Sauce' },
  'worcestershire sauce':   { section: 'flavor', name: 'Worcestershire Sauce' },
  'soy sauce':              { section: 'flavor', name: 'Soy Sauce (Kikkoman)' },
  'msg':                    { section: 'flavor', name: 'MSG (Monosodium Glutamate)' },
  // Accelerators
  'sodium erythorbate':     { section: 'accel',  name: 'Sodium Erythorbate' },
  'acerola':                { section: 'accel',  name: 'Acerola Cherry Powder' },
};

// ── Build a flat list of all DB ingredient names for dropdown ─
function buildAllDBNames() {
  const all = [];
  SECTIONS.forEach(sect => {
    if (sect.isCasingSection) return;
    (DB[sect.key] || []).forEach(entry => {
      all.push({ section: sect.key, sectionLabel: sect.label, name: entry[0] });
    });
  });
  return all;
}

// ── Fuzzy match: keyword overlap score ───────────────────────
function fuzzyMatch(rawName, allNames) {
  const STOPS = new Set(['the','a','an','of','and','or','with','for','in','at','ground','dried','fresh','minced','whole']);
  const raw   = rawName.toLowerCase();
  const words = raw.split(/\s+/).filter(w => !STOPS.has(w));
  if (!words.length) return null;

  let best = null, bestScore = 0;
  allNames.forEach(item => {
    const db    = item.name.toLowerCase();
    const dWords= db.split(/[\s()]+/).filter(w => !STOPS.has(w) && w.length > 1);
    const overlap = words.filter(w => dWords.some(d => d.includes(w) || w.includes(d))).length;
    const score   = overlap / words.length;
    if (score > bestScore) { bestScore = score; best = item; }
  });
  return bestScore >= 0.5 ? { ...best, score: bestScore } : null;
}

// ── Core parser — handles both plain text (browser copy) and markdown ──
function parseRecipeText(raw) {
  // Normalize: collapse excessive whitespace, strip HTML entities
  let text = raw
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/\r\n/g, '\n')
    .replace(/\n{4,}/g, '\n\n\n')
    .trim();

  const result = { name: '', description: '', ingredients: [], noAmountItems: [], sections: [] };

  // ── NOISE LINES to strip (browser copy includes these) ───────
  const NOISE_TESTS = [
    l => /\d+\s*from\s*\d+\s*votes?/i.test(l),
    l => /^(Prep|Cook)\s*Time/i.test(l),
    l => /^[-–]\+\s*servings/i.test(l),
    l => /^Metric(\s*[-–]\s*US Customary)?\s*$/i.test(l),
    l => /^US Customary\s*$/i.test(l),
    l => /^Smaller\s*Normal\s*Larger\s*$/i.test(l),
    l => /(Go Back|Print Recipe|Recipe Image)/i.test(l),
    l => /^(Metric|Smaller|Normal|Larger)$/.test(l),
    l => l.includes('2 Guys') || l.includes('twoguysandacooler'),
    l => /^-?\+\s*servings?/i.test(l),
  ];
  const lines = text.split('\n').filter(line => {
    const l = line.trim();
    if (!l) return true; // keep blank lines for structure
    return !NOISE_TESTS.some(fn => fn(l));
  });
  text = lines.join('\n').replace(/\n{4,}/g, '\n\n\n').trim();

  // ── NAME detection ────────────────────────────────────────────
  // Try markdown: ## Recipe Name
  let nameM = text.match(/^##\s+(.+)$/m);
  if (nameM) {
    result.name = nameM[1].trim();
  } else {
    // Plain text: The recipe name is usually the first substantial line
    // that doesn't look like a site name (contains " - 2 Guys") or noise
    const allLines = text.split('\n').map(l => l.trim()).filter(Boolean);
    for (const line of allLines) {
      // Skip lines with site name, URLs, or short noise
      if (line.includes('2 Guys') || line.includes('twoguys') || line.length < 4) continue;
      if (/^(Ingredients|Instructions|Notes|Equipment)$/i.test(line)) continue;
      // First real title-case or all-caps line is the name
      if (/^[A-Z]/.test(line) && line.length > 4 && line.length < 80) {
        result.name = line;
        break;
      }
    }
  }

  // ── DESCRIPTION ───────────────────────────────────────────────
  // Line(s) immediately after the name, before Ingredients/Instructions section
  if (result.name) {
    const nameIdx = text.indexOf(result.name);
    const afterName = text.slice(nameIdx + result.name.length).trimStart();
    const descLines = [];
    for (const line of afterName.split('\n')) {
      const l = line.trim();
      if (!l) { if (descLines.length) break; continue; }
      // Stop at section headings or ingredient lines
      if (/^#{1,4}\s/.test(l)) break;
      if (/^(Ingredients|Instructions|Equipment)\s*$/i.test(l)) break;
      if (/^[\d.]+\s*(g|ml|oz|lb)\s+/i.test(l)) break;
      descLines.push(l);
    }
    result.description = descLines.join(' ').trim();
  }

  // ── INGREDIENTS ───────────────────────────────────────────────
  // Find the Ingredients block — works for both "### Ingredients" and plain "Ingredients"
  const ingStart = text.search(/^#{0,4}\s*Ingredients\s*$/im);
  const instStart = text.search(/^#{0,4}\s*Instructions\s*$/im);

  if (ingStart !== -1) {
    const ingEnd  = instStart !== -1 ? instStart : text.length;
    const ingText = text.slice(ingStart, ingEnd);

    for (const line of ingText.split('\n')) {
      // Strip leading bullet/dash/star
      const l = line.trim().replace(/^[-*•]\s*/, '');
      if (!l) continue;
      // Skip heading lines
      if (/^#{0,4}\s*(Ingredients|Instructions|Metric|US)/i.test(l)) continue;

      // Match: NUMBER UNIT NAME  (with optional leading dash for markdown)
      const m = l.match(/^([\d]+(?:[.,][\d]+)?)\s*(g|ml|kg|oz|lbs?|tsp|tbsp|cups?)\s+(.+)$/i);
      if (m) {
        const unit = m[2].toLowerCase()
          .replace('lbs','lb').replace('cups','cup');
        result.ingredients.push({
          amount: parseFloat(m[1].replace(',','.')),
          unit,
          name: m[3].trim().replace(/\s+/g,' '),
        });
      } else if (l.length > 1 && l.length < 100 &&
                 !/^(Metric|US Customary|Smaller|Normal)/.test(l)) {
        // Items without amounts (casings, optional items)
        result.noAmountItems.push(l);
      }
    }
  }

  // ── INSTRUCTIONS ──────────────────────────────────────────────
  if (instStart !== -1) {
    const instText = text.slice(instStart);
    let curTitle = null, curSteps = [];

    for (const line of instText.split('\n')) {
      const l = line.trim();
      if (!l) continue;

      // Section heading: #### Title  OR  plain Title line that isn't a bullet
      const isMarkdownHeading = /^#{2,4}\s+/.test(l);
      const isPlainHeading    = !l.startsWith('-') && !l.startsWith('*') &&
                                 !l.match(/^[\d]/) && l.length < 80 &&
                                 /^[A-Z]/.test(l) &&
                                 !/^Instructions/i.test(l);

      if (isMarkdownHeading || (isPlainHeading && curTitle !== null)) {
        if (curTitle !== null && curSteps.length > 0) {
          result.sections.push({ title: curTitle, steps: curSteps });
        }
        curTitle = l.replace(/^#+\s*/, '');
        curSteps = [];
      } else if (curTitle !== null) {
        const step = l.replace(/^[-*•]\s*/, '').trim();
        if (step && step !== curTitle) curSteps.push(step);
      } else if (/^#{0,4}\s*Instructions/i.test(l)) {
        // Skip the "Instructions" heading itself
        curTitle = null;
      }
    }
    if (curTitle !== null && curSteps.length > 0) {
      result.sections.push({ title: curTitle, steps: curSteps });
    }
  }

  return result;
}

// ── Match ingredients against DB ─────────────────────────────
function matchIngredients(ingredients, allDBNames) {
  return ingredients.map(ing => {
    const key    = ing.name.toLowerCase().trim();
    const alias  = ALIASES[key];
    if (alias) {
      return { ...ing, matched: alias, status: 'auto', displayName: alias.name };
    }
    const fuzzy = fuzzyMatch(ing.name, allDBNames);
    if (fuzzy) {
      return { ...ing, matched: { section: fuzzy.section, name: fuzzy.name }, status: 'fuzzy', displayName: fuzzy.name };
    }
    return { ...ing, matched: null, status: 'unmatched', displayName: '' };
  });
}

// ── Section badge map ─────────────────────────────────────────
const STATUS_CONFIG = {
  auto:      { label: '✅ Auto',    cls: 'statusAuto'      },
  fuzzy:     { label: '🔄 Review',  cls: 'statusFuzzy'     },
  unmatched: { label: '❓ No match', cls: 'statusUnmatched' },
  skipped:   { label: '⏭ Skipped', cls: 'statusSkipped'   },
  new:       { label: '➕ New',     cls: 'statusNew'       },
};

// ════════════════════════════════════════════════════════════════
// Main Component
// ════════════════════════════════════════════════════════════════
export default function RecipeImport({ calc, ingDB, onClose }) {
  const [step,       setStep]       = useState(1);   // 1=paste 2=preview 3=review 4=done
  const [rawText,    setRawText]    = useState('');
  const [parsed,     setParsed]     = useState(null);
  const [matchRows,  setMatchRows]  = useState([]);

  const allDBNames = useMemo(() => buildAllDBNames(), []);

  // ── Step 1 → 2: parse the pasted text ──────────────────────
  const handleParse = () => {
    if (!rawText.trim()) return;
    const p = parseRecipeText(rawText);
    if (!p.name && p.ingredients.length === 0) {
      alert('Could not find a recipe in the pasted text. Make sure you copied from the print page (the /wprm_print/ URL).');
      return;
    }
    setParsed(p);
    setStep(2);
  };

  // ── Step 2 → 3: confirm parse, go to review ────────────────
  const handleConfirm = () => {
    const rows = matchIngredients(parsed.ingredients, allDBNames);
    setMatchRows(rows);
    setStep(3);
  };

  // ── Step 3: update a match row ─────────────────────────────
  const updateRow = (idx, updates) => {
    setMatchRows(prev => prev.map((r, i) => i === idx ? { ...r, ...updates } : r));
  };

  // ── Step 3 → 4: import directly into calculator ─────────────
  const handleImport = () => {
    const toImport = matchRows.filter(r => r.status !== 'skipped' && r.matched);

    // Compute meat+fat basis from gram amounts
    const meatFatG = toImport
      .filter(r => r.matched &&
        (r.matched.section === 'meat' || r.matched.section === 'fat') &&
        r.unit === 'g')
      .reduce((sum, r) => sum + r.amount, 0);
    const basis = meatFatG > 0 ? meatFatG : 1000;

    // Convert each row to { sect, name, pct, note }
    const importRows = toImport.map(row => {
      const sect = row.matched.section;
      const name = row.status === 'new'
        ? (row.customName || row.name)
        : row.matched.name;

      let pct = 0;
      if      (row.unit === 'g')  pct = row.amount / basis * 100;
      else if (row.unit === 'ml') pct = row.amount / basis * 100;
      else if (row.unit === 'kg') pct = row.amount * 1000 / basis * 100;
      else if (row.unit === 'oz') pct = row.amount * 28.3495 / basis * 100;
      else if (row.unit === 'lb') pct = row.amount * 453.592 / basis * 100;
      pct = Math.round(pct * 1000) / 1000;

      const note = !['g','ml','kg'].includes(row.unit)
        ? `Original: ${row.amount} ${row.unit}` : '';

      return { sect, name, pct: pct > 0 ? pct.toString() : '', note };
    });

    // Add any brand-new ingredients to the DB first
    toImport.forEach((row, i) => {
      if (row.status === 'new' && ingDB) {
        const pct = parseFloat(importRows[i].pct) || 0;
        ingDB.addIngredient(row.matched.section, {
          name:    importRows[i].name,
          typMin:  pct,
          typMax:  pct,
          hardMax: Math.round(pct * 1.5 * 100) / 100,
        });
      }
    });

    // ── Single atomic call — includes instructions ─────────────
    calc.importRecipe({
      name:     parsed.name        || '',
      notes:    parsed.description || '',
      rows:     importRows,
      sections: parsed.sections   || [],
    });

    setStep(4);
  };

  // ── Meter progress ──────────────────────────────────────────
  const needsReview = matchRows.filter(r => r.status === 'fuzzy' || r.status === 'unmatched').length;
  const autoCount   = matchRows.filter(r => r.status === 'auto').length;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>

        {/* Header */}
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <span className={styles.headerIcon}>📥</span>
            <div>
              <div className={styles.title}>Import Recipe</div>
              <div className={styles.subtitle}>
                From twoguysandacooler.com or any gram-based recipe
              </div>
            </div>
          </div>
          <button className={styles.closeBtn} onClick={onClose}>✕</button>
        </div>

        {/* Step indicator */}
        <div className={styles.steps}>
          {['Paste', 'Preview', 'Review', 'Done'].map((lbl, i) => (
            <div key={i} className={`${styles.stepDot} ${step === i+1 ? styles.stepActive : step > i+1 ? styles.stepDone : ''}`}>
              <div className={styles.stepCircle}>{step > i+1 ? '✓' : i+1}</div>
              <div className={styles.stepLabel}>{lbl}</div>
            </div>
          ))}
        </div>

        {/* ── STEP 1: Paste ── */}
        {step === 1 && (
          <div className={styles.body}>
            <div className={styles.instructions}>
              <strong>How to import from twoguysandacooler.com:</strong>
              <ol className={styles.instrList}>
                <li>Open the recipe page on the site</li>
                <li>Change the URL from <code>/recipe-name/</code> to <code>/wprm_print/recipe-name</code></li>
                <li>On the print page, press <code>Ctrl+A</code> (select all), then <code>Ctrl+C</code> (copy)</li>
                <li>Paste below and click Parse Recipe</li>
              </ol>
              <div className={styles.instrNote}>
                Works with any recipe that lists ingredients in grams with the format:<br />
                <code>700 g pork shoulder</code>
              </div>
            </div>

            <textarea
              className={styles.pasteArea}
              placeholder="Paste the full text from the print page here…"
              value={rawText}
              onChange={e => setRawText(e.target.value)}
              rows={14}
              autoFocus
            />

            <div className={styles.footer}>
              <button className={styles.btnCancel} onClick={onClose}>Cancel</button>
              <button
                className={styles.btnPrimary}
                onClick={handleParse}
                disabled={!rawText.trim()}
              >
                Parse Recipe →
              </button>
            </div>
          </div>
        )}

        {/* ── STEP 2: Preview ── */}
        {step === 2 && parsed && (
          <div className={styles.body}>
            <div className={styles.previewSection}>
              <div className={styles.previewLabel}>Recipe Name</div>
              <div className={styles.previewValue}>{parsed.name || <em className={styles.missing}>Not found</em>}</div>
            </div>

            {parsed.description && (
              <div className={styles.previewSection}>
                <div className={styles.previewLabel}>Description → Recipe Notes</div>
                <div className={styles.previewDesc}>{parsed.description}</div>
              </div>
            )}

            <div className={styles.previewRow}>
              <div className={styles.previewStat}>
                <div className={styles.previewStatNum}>{parsed.ingredients.length}</div>
                <div className={styles.previewStatLbl}>ingredients<br/>with amounts</div>
              </div>
              <div className={styles.previewStat}>
                <div className={styles.previewStatNum}>{parsed.sections.length}</div>
                <div className={styles.previewStatLbl}>instruction<br/>sections</div>
              </div>
              {parsed.noAmountItems.length > 0 && (
                <div className={styles.previewStat}>
                  <div className={styles.previewStatNum}>{parsed.noAmountItems.length}</div>
                  <div className={styles.previewStatLbl}>items without<br/>amounts</div>
                </div>
              )}
            </div>

            {parsed.noAmountItems.length > 0 && (
              <div className={styles.noAmountBox}>
                <div className={styles.noAmountLabel}>Items without gram amounts (not imported):</div>
                {parsed.noAmountItems.map((it, i) => (
                  <span key={i} className={styles.noAmountItem}>{it}</span>
                ))}
                <div className={styles.noAmountNote}>
                  Casings and optional items are noted here for reference.
                  Add them manually in the calculator after importing.
                </div>
              </div>
            )}

            {!parsed.name && (
              <div className={styles.warnBox}>
                ⚠️ Recipe name not detected. You can rename it after importing.
              </div>
            )}
            {parsed.ingredients.length === 0 && (
              <div className={styles.warnBox}>
                ❌ No ingredients were parsed. Make sure you copied from the /wprm_print/ page
                and that the recipe uses gram measurements.
              </div>
            )}

            <div className={styles.footer}>
              <button className={styles.btnSecondary} onClick={() => setStep(1)}>← Back</button>
              <button
                className={styles.btnPrimary}
                onClick={handleConfirm}
                disabled={parsed.ingredients.length === 0}
              >
                Review Ingredients →
              </button>
            </div>
          </div>
        )}

        {/* ── STEP 3: Review ── */}
        {step === 3 && (
          <div className={styles.body}>
            <div className={styles.reviewSummary}>
              <span className={styles.reviewStat}>
                <strong>{autoCount}</strong> auto-matched
              </span>
              {needsReview > 0 && (
                <span className={`${styles.reviewStat} ${styles.reviewWarn}`}>
                  <strong>{needsReview}</strong> need{needsReview === 1 ? 's' : ''} your attention
                </span>
              )}
              {needsReview === 0 && (
                <span className={`${styles.reviewStat} ${styles.reviewGood}`}>
                  All matched — ready to import
                </span>
              )}
            </div>

            <div className={styles.reviewTable}>
              {/* Column headers */}
              <div className={styles.reviewHeader}>
                <span>Parsed ingredient</span>
                <span>Amount</span>
                <span>Our database match</span>
                <span>Status</span>
              </div>

              {matchRows.map((row, idx) => (
                <ReviewRow
                  key={idx}
                  row={row}
                  idx={idx}
                  allDBNames={allDBNames}
                  onUpdate={updateRow}
                />
              ))}
            </div>

            <div className={styles.footer}>
              <button className={styles.btnSecondary} onClick={() => setStep(2)}>← Back</button>
              <button className={styles.btnPrimary} onClick={handleImport}>
                Import into Calculator →
              </button>
            </div>
          </div>
        )}

        {/* ── STEP 4: Done ── */}
        {step === 4 && (
          <div className={styles.body}>
            <div className={styles.doneCard}>
              <div className={styles.doneIcon}>✅</div>
              <div className={styles.doneName}>{parsed?.name}</div>
              <div className={styles.doneMsg}>
                Recipe imported into the calculator.
                {parsed?.description && ' Description saved to Recipe Notes.'}
              </div>
              <ul className={styles.doneChecklist}>
                <li>✓ Ingredients loaded with percentages</li>
                <li>✓ Recipe Notes set from description</li>
                {parsed?.sections?.length > 0 && (
                  <li>✓ {parsed.sections.length} instruction sections ready in Method tab</li>
                )}
              </ul>
              <div className={styles.doneNext}>
                <strong>Next steps in the calculator:</strong>
                <ul className={styles.doneNextList}>
                  <li>Select Sausage Style and Cooking Method</li>
                  <li>Choose a casing in the Casing Calculator</li>
                  <li>Review ingredient matches and adjust if needed</li>
                  <li>Save the recipe</li>
                </ul>
              </div>
            </div>

            <div className={styles.footer}>
              <button className={styles.btnPrimary} onClick={onClose}>
                Open in Calculator →
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ── Review row sub-component ──────────────────────────────────
function ReviewRow({ row, idx, allDBNames, onUpdate }) {
  const [search,    setSearch]    = useState('');
  const [showSearch, setShowSearch] = useState(false);

  const config = STATUS_CONFIG[row.status] || STATUS_CONFIG.unmatched;

  // Filter DB names by search
  const filtered = useMemo(() => {
    if (!search.trim()) return allDBNames.slice(0, 20);
    const q = search.toLowerCase();
    return allDBNames.filter(n => n.name.toLowerCase().includes(q)).slice(0, 20);
  }, [search, allDBNames]);

  const handleSelectDB = (item) => {
    onUpdate(idx, { matched: { section: item.section, name: item.name }, displayName: item.name, status: 'fuzzy' });
    setShowSearch(false);
    setSearch('');
  };

  const handleAddNew = () => {
    onUpdate(idx, { status: 'new', customName: row.name, matched: { section: guessSection(row.name), name: row.name } });
  };

  const handleSkip = () => {
    onUpdate(idx, { status: 'skipped' });
  };

  const handleUnskip = () => {
    onUpdate(idx, { status: 'unmatched', matched: null });
  };

  // Format amount display
  const amtDisplay = `${row.amount} ${row.unit}`;
  const isNonGram  = !['g','ml','kg'].includes(row.unit);

  return (
    <div className={`${styles.reviewRow} ${row.status === 'skipped' ? styles.reviewRowSkipped : ''} ${(row.status === 'unmatched' || row.status === 'fuzzy') ? styles.reviewRowNeeds : ''}`}>

      {/* Parsed name */}
      <div className={styles.reviewCell}>
        <span className={styles.parsedName}>{row.name}</span>
        {isNonGram && (
          <span className={styles.unitWarn} title="Non-gram amount — will be noted, % set to 0">⚠️ {row.unit}</span>
        )}
      </div>

      {/* Amount */}
      <div className={`${styles.reviewCell} ${styles.reviewAmount}`}>
        {amtDisplay}
      </div>

      {/* Match */}
      <div className={styles.reviewCell}>
        {row.status === 'skipped' ? (
          <span className={styles.skippedText}>—</span>
        ) : row.status === 'new' ? (
          <div className={styles.newIngRow}>
            <input
              className={styles.newIngInput}
              value={row.customName || row.name}
              onChange={e => onUpdate(idx, { customName: e.target.value })}
              placeholder="Name for new ingredient"
            />
            <select
              className={styles.newIngSection}
              value={row.matched?.section || 'spice'}
              onChange={e => onUpdate(idx, { matched: { ...row.matched, section: e.target.value } })}
            >
              {SECTIONS.filter(s => !s.isCasingSection).map(s => (
                <option key={s.key} value={s.key}>{s.label}</option>
              ))}
            </select>
          </div>
        ) : showSearch ? (
          <div className={styles.searchBox}>
            <input
              className={styles.searchInput}
              autoFocus
              placeholder="Search database…"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            <div className={styles.searchResults}>
              {filtered.map((item, i) => (
                <button key={i} className={styles.searchResult} onClick={() => handleSelectDB(item)}>
                  <span className={styles.searchResultName}>{item.name}</span>
                  <span className={styles.searchResultSection}>{item.sectionLabel}</span>
                </button>
              ))}
              {filtered.length === 0 && (
                <div className={styles.searchEmpty}>No matches — try Add New below</div>
              )}
            </div>
            <button className={styles.searchCancel} onClick={() => setShowSearch(false)}>Cancel</button>
          </div>
        ) : (
          <div className={styles.matchDisplay}>
            {row.matched ? (
              <span className={styles.matchName}>{row.displayName || row.matched.name}</span>
            ) : (
              <span className={styles.noMatchText}>Not matched</span>
            )}
            <button className={styles.changeBtn} onClick={() => setShowSearch(true)}>
              {row.matched ? 'Change' : 'Search DB'}
            </button>
          </div>
        )}
      </div>

      {/* Status + actions */}
      <div className={`${styles.reviewCell} ${styles.reviewActions}`}>
        <span className={`${styles.statusBadge} ${styles[config.cls]}`}>
          {config.label}
        </span>
        {row.status !== 'skipped' && !showSearch && row.status !== 'new' && (
          <div className={styles.actionBtns}>
            {(row.status === 'unmatched') && (
              <button className={styles.addNewBtn} onClick={handleAddNew} title="Add as new ingredient">
                + Add new
              </button>
            )}
            <button className={styles.skipBtn} onClick={handleSkip} title="Skip this ingredient">
              Skip
            </button>
          </div>
        )}
        {row.status === 'new' && (
          <button className={styles.skipBtn} onClick={handleSkip}>Skip</button>
        )}
        {row.status === 'skipped' && (
          <button className={styles.unskipBtn} onClick={handleUnskip}>Restore</button>
        )}
      </div>
    </div>
  );
}

// Guess section from ingredient name
function guessSection(name) {
  const n = name.toLowerCase();
  if (/pork|beef|chicken|turkey|lamb|venison|meat/.test(n)) return 'meat';
  if (/fat|lard|tallow|belly/.test(n)) return 'fat';
  if (/water|wine|beer|juice|liquid/.test(n)) return 'liquid';
  if (/salt/.test(n)) return 'salt';
  if (/cure|nitrite|prague/.test(n)) return 'cure';
  if (/sugar|honey|syrup|molasses|dextrose/.test(n)) return 'sweet';
  if (/starch|binder|milk|soy protein|egg/.test(n)) return 'binder';
  if (/cheese/.test(n)) return 'cheese';
  if (/smoke|sauce|miso|worcestershire|soy sauce/.test(n)) return 'flavor';
  return 'spice';
}
